import {Injectable, signal} from '@angular/core';
import {ChatHistoryParams} from "../types/chat-history.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramChatHistoryStateService {
  private _telegramChatHistoryState = signal<Array<ChatHistoryParams>>([]);

  public setTelegramChatHistoryState(telegramNotifications: Array<ChatHistoryParams>): void {
    this._telegramChatHistoryState.set(telegramNotifications);
  }

  public getTelegramChatHistoryById(id: number): ChatHistoryParams | null {
    return this._telegramChatHistoryState().find(i => i.recordCalendarId === id) || null;
  }

  public resetTelegramChatHistoryState(): void {
    this._telegramChatHistoryState.set([]);
  }
}
